import React from "react";
import { forwardRef, type HTMLAttributes } from "react";
import { type OddsDirection, useOddsDirection } from "@/hooks/useOddsDirection";

type BetOddsChangeProps = HTMLAttributes<HTMLElement> & {
  odds: number;
  initialOdds?: number;
  animationLength?: number | null;
  oddsDirectionOverride?: OddsDirection;
};

export const BetOddsChange = forwardRef<HTMLDivElement, BetOddsChangeProps>(
  (
    {
      odds,
      initialOdds,
      children,
      animationLength,
      oddsDirectionOverride,
      ...props
    },
    ref,
  ) => {
    const oddsDirection = useOddsDirection(
      odds,
      initialOdds,
      animationLength,
      oddsDirectionOverride,
    );

    return (
      <div ref={ref} {...props} data-status={oddsDirection}>
        {children}
      </div>
    );
  },
);
